import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import HttpErrorResponse from '../interfaces/common/httpErrorResponse';
import Paging from '../interfaces/common/paging';
import Pagination from '../interfaces/common/pagination';
import { RootState } from '../setup';
import YesNo from '../interfaces/output/YesNo';

export type YesNoState = {
    yesNoById: YesNo;
    isLoading: boolean;
    yesNo: Pagination<YesNo>;
    error: HttpErrorResponse | undefined;
};

const initialState: YesNoState = {
    yesNoById: {} as YesNo,
    yesNo: { content: [] as Array<YesNo> } as Pagination<YesNo>,
    isLoading: false,
    error: undefined
};

export const yesNoSlice = createSlice({
    name: 'yesNo',

    initialState,
    reducers: {
        fetchYesNo: (state: YesNoState, _action: PayloadAction<{paging: Paging}>) => {
            state.isLoading = true;
        },
        fetchYesNoSuccess: (state: YesNoState, action: PayloadAction<Pagination<YesNo>>) => {
            state.isLoading = false;
            state.yesNo = action.payload;
        },
        fetchYesNoError: (state: YesNoState, action: PayloadAction<HttpErrorResponse>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        fetchYesNoById: (state: YesNoState, _action: PayloadAction<string>) => {
            state.isLoading = true;
        },
        fetchYesNoByIdSuccess: (state: YesNoState, action: PayloadAction<YesNo>) => {
            state.isLoading = false;
            state.yesNoById = action.payload;
        },
        fetchYesNoByIdError: (state: YesNoState, action: PayloadAction<HttpErrorResponse>) => {
            state.isLoading = false;
            state.error = action.payload;
        }
    }
});

export const { fetchYesNoById, fetchYesNoByIdError, fetchYesNoByIdSuccess,
    fetchYesNo, fetchYesNoError, fetchYesNoSuccess } = yesNoSlice.actions;

export const isLoadingYesNo = (state: RootState): boolean => state.yesNoReducer.isLoading;
export const getYesNo = (state: RootState): Pagination<YesNo> => state.yesNoReducer.yesNo;
export const getYesNoById = (state: RootState): YesNo => state.yesNoReducer.yesNoById;

export default yesNoSlice.reducer;